import { Children, type ReactNode } from "react";
import { Box, Paper, Stack } from "@mantine/core";
import { ECOSYSTEM_EXPLORE_CARD_HEIGHT } from "@/pages/ecosystem-heads/components/ecosystemCorridorPromo.util";

type CorridorCarouselParentCardProps = {
  children: ReactNode;
};

/** Parent matching expert/promo height; packs 1–2 corridor cards with vertical space. */
export default function CorridorCarouselParentCard({ children }: CorridorCarouselParentCardProps) {
  const items = Children.toArray(children);
  const isSingle = items.length === 1;

  return (
    <Paper
      radius="lg"
      withBorder
      p="sm"
      shadow="none"
      w="100%"
      h={ECOSYSTEM_EXPLORE_CARD_HEIGHT}
      style={{
        borderColor: "#E2E8F0",
        backgroundColor: "#FFFFFF",
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.06)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack gap="md" justify="space-between" style={{ flex: 1, minHeight: 0, height: "100%" }}>
        {items.map((child, index) => (
          <Box
            key={index}
            style={{
              flex: isSingle ? "0 0 calc((100% - var(--mantine-spacing-md)) / 2)" : 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {child}
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
